import type { CSSProperties } from 'react';
import '../Surveys.css';

// Legend swatches. The four base styles are listed in the spec; `line+dot`
// is added so pollster legend rows can show both a line stub and a dot
// marker (matching the inspection HTML), without each pollster needing
// two legend entries.
export type LegendStyle = 'line' | 'dot' | 'ring' | 'dashed' | 'line+dot';

export interface LegendItem {
  label: string;
  color: string;
  style?: LegendStyle;
}

interface Props {
  items: LegendItem[];
}

export default function ChartLegend({ items }: Props) {
  return (
    <div className="chart-legend">
      {items.map((item) => (
        <div key={item.label} className="chart-legend__item">
          <Swatch style={item.style ?? 'line'} color={item.color} />
          <span className="chart-legend__label">{item.label}</span>
        </div>
      ))}
    </div>
  );
}

function Swatch({ style, color }: { style: LegendStyle; color: string }) {
  switch (style) {
    case 'line':
      return <span className="chart-legend__line" style={{ background: color }} />;
    case 'dot':
      return <span className="chart-legend__dot" style={{ background: color }} />;
    case 'ring':
      return <span className="chart-legend__ring" style={{ borderColor: color }} />;
    case 'dashed':
      return (
        <span
          className="chart-legend__dashed"
          style={{ color } as CSSProperties}
        />
      );
    case 'line+dot':
      return (
        <span className="chart-legend__line-dot">
          <span className="chart-legend__line" style={{ background: color }} />
          <span className="chart-legend__dot" style={{ background: color }} />
        </span>
      );
  }
}
